import { Dialog, Toast } from 'vant'
import { login } from '@/api'
import VuexCommonMix from '@/store/vuexCommonMix'
export default {
  components: {},
  mixins: [VuexCommonMix],
  props: [],
  name: 'login-page',
  data () {
    return {
      username: null,
      password: null
    }
  },
  computed: {
    // x: function() {}
  },
  watch: {
    // x: function(val) {}
  },
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    forgetPwd () {
      Dialog({ message: '请联系裴老师进行密码修改 微信号：xdf_15510135076' })
    },
    // 登录按钮被点击
    async loginBtnClicked () {
      if (this.username === null || this.username === '') { Toast({ message: '请输入用户名', type: 'fail' }); return }
      if (this.password === null || this.username === '') { Toast({ message: '请输入密码', type: 'fail' }); return }
      const { data, error } = await login(this.username, this.password)
      await this.initUserInfo(data)
      if (error.returnCode === 0) { this.$router.push({ path: '/home' }) }
    }
  }
}
